import React from 'react';
import { IconButton, Typography } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SearchBar from './SearchBar';

const TopNav = ({ showSearch = true, onSearch }) => {
  const navigate = useNavigate();
  const { currentUser, signOut } = useAuth();

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div className="top-nav">
      <div className="user-profile">
        <Typography variant="subtitle1" fontWeight="bold">
          {currentUser.displayName}
        </Typography>
      </div>
      <div className="top-nav-right">
        {showSearch && (
          <div className="search-wrapper">
            <SearchBar onSearch={onSearch} />
          </div>
        )}
        <IconButton
          color="primary"
          aria-label="logout"
          onClick={handleLogout}
          className="logout-button"
          sx={{
            ml: 1,
            bgcolor: '#f0f4f8',
            '&:hover': {
              bgcolor: '#e1e6ea',
            },
          }}
        >
          <LogoutIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default TopNav;